import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import styles from './FeaturedClothingHeader.module.scss';
export function FeaturedClothingHeader({ collectionId }) {
    const content = useMemo(() => {
        var _a, _b;
        if (typeof document === 'undefined')
            return '';
        const scriptEl = collectionId
            ? document.getElementById(`plp-featured-clothing-header-${collectionId}`)
            : document.querySelector('[id^="plp-featured-clothing-header-"]');
        return (_b = (_a = scriptEl === null || scriptEl === void 0 ? void 0 : scriptEl.textContent) === null || _a === void 0 ? void 0 : _a.replace(/__SCRIPT_END__/g, '</script>').trim()) !== null && _b !== void 0 ? _b : '';
    }, [collectionId]);
    if (!content)
        return null;
    const isHtml = /<[a-z][\s\S]*>/i.test(content);
    return (h("div", { class: styles.featuredClothingSection },
        h("div", { class: styles.featuredClothingTextBlock }, isHtml ? (h("div", { dangerouslySetInnerHTML: { __html: content } })) : (h("h2", { class: styles.featuredClothingTitle }, content)))));
}
